import React from 'react';
import { RevealOnScroll } from './RevealOnScroll';
interface Testimonial {
  initials: string;
  name: string;
  age: number;
  location: string;
  quote: string;
}
const testimonials: Testimonial[] = [{
  initials: 'MC',
  name: 'María Carmen',
  age: 52,
  location: 'Miami, FL',
  quote: 'En 2 semanas los sofocos bajaron casi a la mitad. Por fin duermo de corrido.'
}, {
  initials: 'LP',
  name: 'Luz Patricia',
  age: 48,
  location: 'Houston, TX',
  quote: 'Pensé que tenía que aguantar 10 años así. La guía me devolvió la calma y bajé 4 libras sin proponérmelo.'
}, {
  initials: 'RG',
  name: 'Rosa Gloria',
  age: 55,
  location: 'Los Angeles, CA',
  quote: 'Lo mejor: está en español de verdad, no traducido. Se siente como hablar con una amiga.'
}];
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-10 md:py-16" aria-labelledby="testimonials-heading" data-id="element-193">
      <div className="mx-auto max-w-container" data-id="element-194">
        <h2 id="testimonials-heading" className="font-serif text-[22px] font-medium text-wine md:text-[24px]" data-id="element-195">
          Mujeres como tú ya lo están viviendo
        </h2>

        <div className="mt-6 flex flex-col gap-4" data-id="element-196">
          {testimonials.map((t, i) => <RevealOnScroll key={i} delay={i * 0.08} data-id="element-197">
              <article className="rounded-[12px] bg-cream p-4 md:p-5" data-id="element-198">
                <div className="flex items-start gap-3" data-id="element-199">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white" style={{
                backgroundColor: '#ED93B1'
              }} aria-hidden="true" data-id="element-200">
                    <span className="text-[14px] font-semibold" data-id="element-201">
                      {t.initials}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-202">
                    <p className="text-[14px] font-medium text-wine" data-id="element-203">
                      {t.name}, {t.age}
                    </p>
                    <p className="text-[12px] text-rose" data-id="element-204">
                      <span aria-label="5 estrellas" data-id="element-205">⭐⭐⭐⭐⭐</span> ·{' '}
                      {t.location}
                    </p>
                  </div>
                </div>
                <blockquote className="mt-3 font-serif italic text-[14px] leading-relaxed text-burgundy" data-id="element-206">
                  "{t.quote}"
                </blockquote>
              </article>
            </RevealOnScroll>)}
        </div>
      </div>
    </section>;
}